/**
 * The coin sound, played when coins are collected in a badge moment - the only sound effect (owner 2026-10-08: no
 * sounds on buttons or steps). Synthesised with Web Audio, nothing downloaded: the same two square tones the
 * reviewers liked in the prototype. Silent off the web or where audio is unavailable.
 */
let context = null;

function audio() {
  try {
    if (typeof window === 'undefined') return null;
    const Context = window.AudioContext || window.webkitAudioContext;
    if (!Context) return null;
    if (!context) context = new Context();
    if (context.state === 'suspended') context.resume();
    return context;
  } catch (_) {
    return null;
  }
}

function tone(c, freq, at, duration) {
  const start = c.currentTime + at;
  const oscillator = c.createOscillator();
  const gain = c.createGain();
  oscillator.type = 'square';
  oscillator.frequency.setValueAtTime(freq, start);
  gain.gain.setValueAtTime(0, start);
  gain.gain.linearRampToValueAtTime(0.025, start + 0.012);
  gain.gain.exponentialRampToValueAtTime(0.0001, start + duration);
  oscillator.connect(gain).connect(c.destination);
  oscillator.start(start);
  oscillator.stop(start + duration + 0.05);
}

/** `count` quick coin chimes. */
export function playCoins(count = 1) {
  const c = audio();
  if (!c) return;
  for (let i = 0; i < count; i += 1) {
    tone(c, 1318, i * 0.07, 0.09);
    tone(c, 1760, i * 0.07 + 0.05, 0.16);
  }
}
